// extracted by mini-css-extract-plugin
export default {"card":"p4-z"};